module.exports = [function () {
    return {
        restrict: "E",
        replace: true,
        templateUrl: '/static/partials/configuration/plant-details.html',
        controller: 'PlantDetailsCtrl',
        scope: {
            permissions: '=',
            plant: '='
        },
        link: function link(scope, $element, $attrs) {

        }
    };
}];
